import React, { useState } from 'react';
import { useStrategyInsights } from '../../context/StrategyInsightsContext';
import { useSupabaseAuth } from '../../hooks/useSupabaseAuth';
import StrategyDashboardPanel from './StrategyDashboardPanel';
import PublicQuickLinksModal from './PublicQuickLinksModal';

const StrategyDashboardSprout = () => {
  const { user, loading: authLoading } = useSupabaseAuth();
  const { insights, summary, loading: insightsLoading } = useStrategyInsights();
  const [isOpen, setIsOpen] = useState(false);
  const [hasSeenPublicModal, setHasSeenPublicModal] = useState(() => {
    return localStorage.getItem('has_seen_public_quick_links') === 'true';
  });

  // If auth is loading, we shouldn't show the sprout yet to avoid layout pop
  if (authLoading) return null;

  const isPublicUser = !user;

  const handleOpen = () => {
    setIsOpen(true);
    if (isPublicUser && !hasSeenPublicModal) {
      localStorage.setItem('has_seen_public_quick_links', 'true');
      setHasSeenPublicModal(true);
    }
  };

  // Determine pulse state
  let pulseClass = "shadow-lg hover:scale-105";
  if (!isPublicUser && !insightsLoading && insights.length > 0) {
    if (summary.high_priority > 0) {
      pulseClass = "pulse-active shadow-[0_0_0_rgba(64,224,208,0.7)] animate-[pulseActive_2s_ease-in-out_infinite]";
    } else {
      pulseClass = "pulse-gentle animate-[pulseGentle_3s_ease-in-out_infinite]";
    }
  } else if (isPublicUser && !hasSeenPublicModal) {
    // Pulse green for public users until they click it
    pulseClass = "pulse-active shadow-[0_0_0_rgba(64,224,208,0.7)] animate-[pulseActive_2s_ease-in-out_infinite]";
  }

  return (
    <>
      <style>{`
        @keyframes pulseGentle {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.9; }
        }
        @keyframes pulseActive {
          0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(64, 224, 208, 0.7); }
          50% { transform: scale(1.1); box-shadow: 0 0 0 10px rgba(64, 224, 208, 0); }
        }
      `}</style>

      <button
        onClick={handleOpen}
        className={`fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 bg-white dark:bg-charcoal-900 border border-charcoal-200 dark:border-charcoal-700 rounded-full transition-all focus:outline-none ${pulseClass}`}
        aria-label={isPublicUser ? "Quick Links" : "Strategy Dashboard"}
      >
        <img src="/images/Julie_Adams.png" alt="Julie Adams" className="w-12 h-12 rounded-full object-cover" />

        {!isPublicUser && !insightsLoading && insights.length > 0 && (
          <span className={`absolute -top-2 -right-2 flex items-center justify-center min-w-[24px] h-[24px] px-1.5 rounded-full text-xs font-bold text-white shadow-sm ${
            summary.high_priority > 0 ? 'bg-red-500' : 'bg-blue-600'
          }`}>
            {insights.length > 9 ? '9+' : insights.length}
          </span>
        )}
      </button>

      {isPublicUser ? (
        <PublicQuickLinksModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      ) : (
        <StrategyDashboardPanel isOpen={isOpen} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
};

export default StrategyDashboardSprout;
